import { StateCreator } from "zustand";
import {
  WidgetStore,
  ConversationState,
  ConversationActions,
  Message,
  ConversationItem,
} from "../types";

const initialConversationState: ConversationState = {
  messages: [],
  transcript: [],
  conversationItems: [],
};

export const createConversationSlice: StateCreator<
  WidgetStore,
  [],
  [],
  ConversationState & ConversationActions
> = (set) => ({
  ...initialConversationState,

  addMessage: (message) =>
    set((state) => ({
      messages: [...state.messages, message],
    })),

  addTranscript: (transcriptMessage) =>
    set((state) => ({
      transcript: [...state.transcript, transcriptMessage],
    })),

  addConversationItem: (item) =>
    set((state) => ({
      conversationItems: [...state.conversationItems, item],
    })),

  setMessages: (messages) => set({ messages }),
  setTranscript: (transcript) => set({ transcript }),
  setConversationItems: (conversationItems) => set({ conversationItems }),

  clearMessages: () => set({ messages: [] }),
  clearTranscript: () => set({ transcript: [] }),
  clearConversationItems: () => set({ conversationItems: [] }),
  resetConversation: () => set(initialConversationState),
});
